const LAST_SPACE_ID_KEY = 'teufel_last_space_id';

export const useSpacePersistence = () => {
    const saveLastSpaceId = (spaceId) => {
        try {
            localStorage.setItem(LAST_SPACE_ID_KEY, spaceId);
        } catch (error) {
            console.warn('Failed to save last space ID to localStorage:', error);
        }
    };

    const getLastSpaceId = () => {
        try {
            return localStorage.getItem(LAST_SPACE_ID_KEY);
        } catch (error) {
            console.warn('Failed to retrieve last space ID from localStorage:', error);
            return null;
        }
    };

    const clearLastSpaceId = () => {
        try {
            localStorage.removeItem(LAST_SPACE_ID_KEY);
        } catch (error) {
            console.warn('Failed to clear last space ID from localStorage:', error);
        }
    };

    return { saveLastSpaceId, getLastSpaceId, clearLastSpaceId };
};
